/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import FormyField from "../field";
import FormyComponent from "../index";

type Args =
  | { parent: FormyComponent; key: string }
  | {
      parent: FormyField;
      key: never;
    };

interface Signature {
  Args: Args;
}

interface Signature {
  Args: Args;
}

export default class FormyCheckboxComponent extends Component<Signature> {
  get id(): FormyField["id"] | undefined {
    return this.args.parent instanceof FormyField
      ? this.args.parent.id
      : undefined;
  }

  get errorId(): FormyField["errorId"] {
    return this.args.parent instanceof FormyField
      ? this.args.parent.errorId
      : undefined;
  }

  get formy(): FormyComponent {
    if (this.args.parent instanceof FormyComponent) return this.args.parent;
    return this.args.parent.args.formy;
  }

  get changeset(): EmberChangeset {
    return this.formy.args.changeset;
  }

  get key(): string {
    return this.args.parent instanceof FormyField
      ? this.args.parent.args.key
      : this.args.key;
  }
}
